import './MonitorNotifications.scss';

import classNames from 'classnames';
import { isEqual } from 'lodash';
import { MonitoringSchedule } from '@sonar-software/sonar-core';
import { SonarStakeholder } from '@ui/SonarStakeholder';
import { SonarText } from '@ui/text';
import { StakeholderSelector } from '@ui/StakeholderSelector';
import { usePrevious } from '@hooks';

import { COPY_SPECIFIC, SETTINGS_DATA_SECURITY_COPY } from '@sonar-software/sonar-ts-constants';
import { Else, If, Then, When } from 'react-if';
import { Form, Radio, Space } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';

export interface MonitorNotificationsProps {
	editing?: boolean,
	fieldId?: number
	stakeholderIds?: number[],
	schedule?: MonitoringSchedule;
}

export const MonitorNotifications : React.FC<MonitorNotificationsProps> = ({
	editing,
	fieldId,
	stakeholderIds = [],
	schedule
}) => {
	const [ emails, setEmails ] = useState<Array<number>>(stakeholderIds);
	const previousIds = usePrevious(stakeholderIds, stakeholderIds);
	const emailsSelected = emails.length > 0;

	const handleChange = useCallback((ids: number[]) => {
		setEmails(ids);
	}, []);

	useEffect(() => {
		if (!isEqual(stakeholderIds, previousIds)) {
			setEmails(stakeholderIds);
		}
	}, [ stakeholderIds, previousIds ]);

	return (
		<div className='app-monitor-notifications'>
			<SonarText
				className={ classNames('h3', 'app-monitor-notifications-title') }
				weight='semibold'>
				{ SETTINGS_DATA_SECURITY_COPY.NOTIFICATION_SETTINGS }
			</SonarText>
			<div className='app-monitor-notifications-schedule'>
				<If condition={ editing }>
					<Then>
						<Form.Item
							className='monitor-email-to'
							id='monitor-email-to'
							initialValue={ emails }
							label={ COPY_SPECIFIC.EMAIL }
							name={ fieldId === undefined ? 'stakeholderIds' : [ fieldId, 'stakeholderIds' ] }
							validateTrigger={ [ 'onChange', 'onBlur' ] }>
							<StakeholderSelector
								direction='horizontal'
								mode='multiple'
								onChange={ handleChange }
								placeholder={ COPY_SPECIFIC.SELECT_USER } />
						</Form.Item>
						<When condition={ emailsSelected }>
							<Form.Item
								className='monitor-schedule-options'
								hidden
								initialValue={ MonitoringSchedule.Immediately }
								name={ fieldId === undefined ?
									'notificationSchedule' :
									[ fieldId, 'notificationSchedule' ] }>
								<Radio.Group
									className='monitor-schedule-options-items'
									options={ Object.values(MonitoringSchedule) }
									size='small'
									value={ schedule ?? MonitoringSchedule.Immediately } />
							</Form.Item>
						</When>
					</Then>
					<Else>
						<If condition={ emailsSelected }>
							<Then>
								<div className='monitor-email-to'>
									<SonarText>{ COPY_SPECIFIC.EMAIL }</SonarText>
									<Space
										className='monitor-schedule-selection'
										direction='horizontal'
										wrap>
										{ emails?.map((id) =>
											<SonarStakeholder
												key={ id }
												showTooltip
												stakeholderId={ id } />) }
									</Space>
								</div>
							</Then>
							<Else>
								<SonarText
									className='app-monitor-no-notifications'>
									{ SETTINGS_DATA_SECURITY_COPY.NO_NOTIFICATIONS }
								</SonarText>
							</Else>
						</If>
					</Else>
				</If>
			</div>
		</div>);
};

